import React from 'react'
import Relibale_hosting from "../../assets/images/Reliable-Hosting.png"
import Click_Installer from "../../assets/images/Click-Installer.png"
import data_warehouse from "../../assets/images/data-warehouse.png"
import Happy_Clients from "../../assets/images/Happy-Clients.png"
import Live_Chat from "../../assets/images/Live-Chat.png"
const Why_Locknpay = () => {
  return (
    <div>
      {/* <!-- Why sokumi --> */}
    <section class="relative">
        <div class="absolute inset-0 bg-neutral-950 left-0 right-0"></div>
        <div class="relative py-10 md:py-24 sm:py-32 overflow-hidden">
            <div class="mx-auto max-w-7xl px-6 lg:px-8">
                <div class="mx-auto max-w-2xl text-center mb-10">
                    <div
                        class="inline-flex items-center px-4 py-2 rounded-full bg-blue-950 border border-blue-800/30 mb-4">
                        <span class="text-sm font-medium text-blue-400"> The features your business needs </span>
                    </div>
                    <h2 class="text-3xl text-white font-bold tracking-tight sm:text-4xl"><span class="sm:inline md:inline">Why
                            Locknpay?</span></h2>
                </div>
                <div class="relative">
                    <div class="px-4 -mx-4 md:px-0 md:mx-0">
                        <div class="flex transition-transform duration-500 ease-out">
                            <div class="w-full flex-shrink-0 px-4 md:px-0">
                                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-8">
                                    <div class="relative group md:transform-none">
                                        <div
                                            class="relative text-center backdrop-blur-xl bg-gray-900/50 rounded-xl p-8 h-full border border-blue-900/10 hover:border-blue-800/50 transition-colors duration-300">
                                            <div class="relative shape_icon mb-4">
                                                <div
                                                    class="h-28 rounded-full w-[80px] mx-auto relative mt-3 z-10 top-8">
                                                    <img src={Live_Chat} width="50" alt="" />
                                                </div>
                                                <svg class="size-full absolute -z-1 ltr:left-0 rtl:right-0 text-primarylight duration-1000 top-[-5px]"
                                                    width="114" height="128" viewBox="0 0 114 128" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M114 70.3998C114 101.88 88.4802 127.4 57 127.4C25.5198 127.4 0 101.88 0 70.3998C1.82688e-05 19.8998 41 -15.6002 50.4737 6.89984C70.4737 54.3998 114 28.8999 114 70.3998Z"
                                                        fill="#018EEC" />
                                                </svg>
                                            </div>
                                            <h4 class="text-white hover:text-blue-700 font-semibold">24/7 Live Chat
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="relative group md:transform-none">
                                        <div
                                            class="relative text-center backdrop-blur-xl bg-gray-900/50 rounded-xl p-8 h-full border border-blue-900/10 hover:border-blue-800/50 transition-colors duration-300">
                                            <div class="relative shape_icon mb-4">
                                                <div
                                                    class="h-28 rounded-full w-[80px] mx-auto relative mt-3 z-10 top-8">
                                                    <img src={Click_Installer} width="50" alt="" />
                                                </div>
                                                <svg class="size-full absolute -z-1 ltr:left-0 rtl:right-0 text-primarylight duration-1000 top-[-5px]"
                                                    width="114" height="128" viewBox="0 0 114 128" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M114 70.3998C114 101.88 88.4802 127.4 57 127.4C25.5198 127.4 0 101.88 0 70.3998C1.82688e-05 19.8998 41 -15.6002 50.4737 6.89984C70.4737 54.3998 114 28.8999 114 70.3998Z"
                                                        fill="#4E8D06" />
                                                </svg>
                                            </div>
                                            <h4 class="text-white hover:text-blue-700 font-semibold">One Click Installer</h4>
                                        </div>
                                    </div>
                                    <div class="relative group md:transform-none">
                                        <div
                                            class="relative text-center backdrop-blur-xl bg-gray-900/50 rounded-xl p-8 h-full border border-blue-900/10 hover:border-blue-800/50 transition-colors duration-300">
                                            <div class="relative shape_icon mb-4">
                                                <div
                                                    class="h-28 rounded-full w-[80px] mx-auto relative mt-3 z-10 top-8">
                                                    <img src={Relibale_hosting} width="50" alt="" />
                                                </div>
                                                <svg class="size-full absolute -z-1 ltr:left-0 rtl:right-0 text-primarylight duration-1000 top-[-5px]"
                                                    width="114" height="128" viewBox="0 0 114 128" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M114 70.3998C114 101.88 88.4802 127.4 57 127.4C25.5198 127.4 0 101.88 0 70.3998C1.82688e-05 19.8998 41 -15.6002 50.4737 6.89984C70.4737 54.3998 114 28.8999 114 70.3998Z"
                                                        fill="#064B8D" />
                                                </svg>
                                            </div>
                                            <h4 class="text-white hover:text-blue-700 font-semibold">Reliable Hosting</h4>
                                        </div>
                                    </div>
                                    <div class="relative group md:transform-none">
                                        <div
                                            class="relative text-center backdrop-blur-xl bg-gray-900/50 rounded-xl p-8 h-full border border-blue-900/10 hover:border-blue-800/50 transition-colors duration-300">
                                            <div class="relative shape_icon mb-4">
                                                <div
                                                    class="h-28 rounded-full w-[80px] mx-auto relative mt-3 z-10 top-8">
                                                    <img src={data_warehouse} width="50" alt="" />
                                                </div>
                                                <svg class="size-full absolute -z-1 ltr:left-0 rtl:right-0 text-primarylight duration-1000 top-[-5px]"
                                                    width="114" height="128" viewBox="0 0 114 128" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M114 70.3998C114 101.88 88.4802 127.4 57 127.4C25.5198 127.4 0 101.88 0 70.3998C1.82688e-05 19.8998 41 -15.6002 50.4737 6.89984C70.4737 54.3998 114 28.8999 114 70.3998Z"
                                                        fill="#643600" />
                                                </svg>
                                            </div>
                                            <h4 class="text-white hover:text-blue-700 font-semibold">+10 Datacenters</h4>
                                        </div>
                                    </div>
                                    <div class="relative group md:transform-none">
                                        <div
                                            class="relative text-center backdrop-blur-xl bg-gray-900/50 rounded-xl p-8 h-full border border-blue-900/10 hover:border-blue-800/50 transition-colors duration-300">
                                            <div class="relative shape_icon mb-4">
                                                <div
                                                    class="h-28 rounded-full w-[80px] mx-auto relative mt-3 z-10 top-8">
                                                    <img src={Happy_Clients} width="50" alt="" />
                                                </div>
                                                <svg class="size-full absolute -z-1 ltr:left-0 rtl:right-0 text-primarylight duration-1000 top-[-5px]"
                                                    width="114" height="128" viewBox="0 0 114 128" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M114 70.3998C114 101.88 88.4802 127.4 57 127.4C25.5198 127.4 0 101.88 0 70.3998C1.82688e-05 19.8998 41 -15.6002 50.4737 6.89984C70.4737 54.3998 114 28.8999 114 70.3998Z"
                                                        fill="#005364" />
                                                </svg>
                                            </div>
                                            <h4 class="text-white hover:text-blue-700 font-semibold">+1K Happy Clients</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Why sokumi end --> */}

    </div>
  )
}

export default Why_Locknpay
